import RemarkService from '@/services/RemarkService'

export function createQuoteRemarksAutoSaveHelper(onSavingChange) {
  let _queue = Promise.resolve()
  let _pendingCount = 0

  function enqueue(operation) {
    _pendingCount++
    if (_pendingCount === 1) onSavingChange?.(true)

    const slot = _queue
      .then(operation)
      .catch(() => {})
      .finally(() => {
        _pendingCount--
        if (_pendingCount === 0) onSavingChange?.(false)
      })

    _queue = slot
    return slot
  }

  return {
    add(remark) {
      enqueue(async () => {
        await RemarkService.postEntity(remark)
        remark.isNew = false
      })
    },
    update(remark) {
      enqueue(() => RemarkService.putEntity(remark))
    },
    pin(affectedRemarks) {
      enqueue(async () => {
        for (const remark of affectedRemarks) {
          await RemarkService.putEntity(remark)
        }
      })
    },
    delete(remark) {
      // Always enqueue — for new remarks whose add hasn't fired yet, the queue runs
      // add first (same client GUID is honoured server-side), then delete.
      enqueue(() => RemarkService.deleteEntity(remark.remarkId))
    },
    saveIncidentNotes(remark) {
      return enqueue(async () => {
        if (remark.isNew || !remark.remarkId) {
          await RemarkService.postEntity(remark)
          remark.isNew = false
        } else {
          await RemarkService.putEntity(remark)
        }
      })
    }
  }
}
